export default __webpack_public_path__ + "static/media/yeopen_main_mobile.8e73392a.jpg";